module.exports = __webpack_public_path__ + "img/c2d06bd.jpg";